<template>
  <div id="announcements" class="bg-white">
    <div
      class="container flex flex-wrap justify-between flex-row pt-16 px-4 sm:px-0"
    >
      <div class="w-full">
      <!-- 
        <h1 class="font-bold text-red text-center text-3xl md:text-4xl">
          UPOZORNĚNÍ
        </h1>
      -->
        <!-- 
      <ul class="list-decimal pl-4">
          <li
            class="text-secondary-text pt-4"
          >Všichni prosím omezte pobyt mimo domov na nezbytné mimimum.</li>
          <li class="text-secondary-text pt-4">
            Pacienti, na které se dle nařízení vlády vztahuje karanténa a mají zároveň příznaky onemocnění - je nutné aby informovali PL, hygienickou stanici tel: 483 311 511 nebo linku 112
            <br />Pacientům v karanténě vystavujeme e-neschopenku na základě telefonické domluvy.
          </li>
          <li
            class="text-secondary-text pt-4"
          >Péči omezujeme pouze na pacienty s akutními potížemi po předchozí telefonické domluvě a to z důvodu omezení počtu pacientů v čekárně. Budete objednaní na konkrétní čas. Toto se týká i pacientů již s probíhající pracovní neschopností.</li>
          <li
            class="text-secondary-text pt-4"
          >Do doby odvolání pozastavujeme poskytování preventivních prohlídek, očkování, vydávání řidičských a zbrojních průkazů, posudky, výpisy z dokumentace, pracovně- lékařské služby, ap.</li>
          <li
            class="font-semibold pt-4 text-red"
          >Recepty pravidelně užívaných léků vystavujeme pouze formou e-receptu (bude Vám zaslána sms s kodem receptu).</li>
          <li
            class="pt-4 text-secondary-text"
          >Vzhledem k plošnému nedostatku ochranných pomůcek je možné, že dojde k dočasnému omezení provozu ordinace. Sledujte prosím aktuální informace na dveřích naší ordinace nebo na webových stránkách</li>
        </ul> 
         -->
      </div> 
      <!--
      <div class="bg-light-blue w-full pt-6 pb-8 mt-8 rounded-lg text-center flex flex-col items-center">
        <h2
          class="text-2xl md:text-3xl font-bold md:font-semibold underline px-6"
        >
          úpravy prostor v ordinaci na Janově
        </h2>

        <p class="pt-6 font-semibold text-lg px-4 text-secondary-text max-w-3xl text-cente ">
           Z technických důvodu ordinace nyní jen na poliklinice Jablonec n.n  Odběry krve ve čtvrtek - prosím domluvit jinou cestou (poliklinika nebo nemocnice JBC) 
           <a href="tel:483705519">
            <b>483 705 519</b>
          </a> 
        </p>
        <p class="pt-2 font-semibold text-lg px-4 text-secondary-text">
          Požadavky na recepty možno zasílat formou sms na tel: <b>601 538 013</b>
        </p>
      </div> 
        -->
      <!-- 
      <div class="bg-light-blue w-full pt-6 pb-8 mt-8 rounded-lg text-center">
        <h2
          class="text-2xl md:text-3xl font-bold md:font-semibold underline px-6"
        >
          Zástup 26.7 - 6.8. MUDr. Olga Svobodová
        </h2>

        <p class="pt-6 font-semibold text-lg px-4 text-secondary-text">
          tel:
          <a href="tel:483313262"> <b>483 313 262</b> </a> | Dolní náměstí
        </p> 
      <p class="pt-2 font-semibold text-lg px-4 text-secondary-text">
          Pouze akutní případy - po telefonické domluvě
        </p> 
      </div> 
      <p
        style="margin: 0 auto;"
        class="pt-8 font-semibold text-2xl text-center"
      >
        Požadavky na léky ev. formou sms na tel:
        <a href="sms:601538013&body=">601 538 013</a>
      </p>  
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Announcements',
  data() {
    return {};
  },
};
</script>

<style scoped></style>
